export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./axis.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/index.js
// module id = 440
// module chunks = 0